<template>
	<div class="container">
		<el-container style="height: 100%;min-height:100vh; padding: 0px;" direction="vertical">
			<el-header class='header flex' height="60px">
				<span class="i-title">样本管理后台</span>
				<section class="flex">
					<span class="userName" v-if="0">管理员名称</span>
					<span type="text" disabled class="exit" @click="modifyPsw">修改密码</span>
					<span type="text" disabled class="exit" @click="exitSystem">退出系统</span>
				</section>
			</el-header>
			<el-container>
				<el-aside v-bind:style="{height:asideHeight}" width="158px"
					style="display: flex; justify-content: center;">
					<el-menu :default-active="activeIndex" class="el-menu-vertical-demo" @select="menuSelected">
						<el-menu-item v-for="(item,index) in tablist" v-if="item.show" :index="''+index" :key="index">
							<i :class="item.class"></i>
							<span slot="title">{{item.name}}</span>
						</el-menu-item>
					</el-menu>
				</el-aside>
				<el-main>
					<router-view></router-view>
					<!-- <keep-alive>
						<router-view></router-view>
					</keep-alive> -->
				</el-main>
			</el-container>
			<el-dialog title="修改密码" :visible.sync="isModify" width="500px" class="changep">
				<el-form ref="moneyform" label-width="120px" style="width:80%;">
					<el-form-item label="原密码">
						<el-input style="display:none;" placeholder="请再次输入新密码" type="password" show-password></el-input>
						<el-input v-model="modifyInfo.oldPasswd" placeholder="请输入原始密码" type="password" show-password>
						</el-input>
					</el-form-item>
					<el-form-item label="新密码">
						<el-input v-model="modifyInfo.passwd" placeholder="请输入新密码" type="password" show-password>
						</el-input>
					</el-form-item>
					<el-form-item label="再次输入新密码">
						<el-input v-model="modifyInfo.passwd1" placeholder="请再次输入新密码" type="password" show-password>
						</el-input>
						
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button class="dialogbt" type="primary" @click="doModifyPsw" size="medium">确定</el-button>
					<el-button class="dialogbt" @click="isModify = false" size="medium">取 消</el-button>
				</div>
			</el-dialog>
		</el-container>
	</div>
</template>

<script>
	import {
		mapGetters,
		mapMutations
	} from 'vuex';
	import api from '../../services/index/api.js'
	import cookie from '../../common/cookie.js'
	export default {
		name: 'index',
		data() {
			return {
				activeIndex: cookie.get('activeIndex') ? cookie.get('activeIndex') : '0',
				geneBrandId:cookie.get('geneBrandId'),
				asideHeight: '600px',
				isModify: false,
				modifyInfo: {
					passwd: '',
					passwd1: '',
					oldPasswd: ''
				},
				tablist:[
					{class:"el-icon-menu",name:"样本管理",show:true,url:"/sample/list"},
					{class:"el-icon-s-platform",name:"报告管理",show:true,url:"/report/manage"},
					{class:"el-icon-s-promotion",name:"报告寄送",show:false,url:"/report/send"},
					{class:"el-icon-s-order",name:"发票信息",show:false,url:"/report/bill"},
					
				],
			}
		},

		computed: {
			...mapGetters([
				'user',
				'baseUrl'
			])
		},
		created() {
			if(!this.geneBrandId) {this.tablist[2].show = true;this.tablist[3].show = true;}
			let windowHeight = window.document.documentElement.clientHeight;
			this.asideHeight = windowHeight - 60 + 'px';
			this.$router.replace(this.tablist[this.activeIndex].url);
		},
		watch: {
			//监听路由变化
			$route(to, from) {
				// console.log(to, from)
			}
		},
		methods: {
			handleClose() {},
			menuSelected(index) {
				this.activeIndex = index
				cookie.set('activeIndex', index)
				this.$router.replace(this.tablist[index].url);
			},
			modifyPsw() {
				this.isModify = true
			},
			doModifyPsw() {
				if (!this.modifyInfo.oldPasswd) {
					this.$message.error('请输入原始密码')
					return
				}
				if (!this.modifyInfo.passwd) {
					this.$message.error('请输入新密码')
					return
				}
				if (this.modifyInfo.passwd!=this.modifyInfo.passwd1) {
					this.$message.error('两次输入新密码有误')
					return
				}
				api.modifyPsw(this.modifyInfo).then((res) => {
					this.isModify = false
					this.$message.success('修改成功')
					this.modifyInfo = {
						passwd: '',
						passwd1: '',
						oldPasswd: ''
					}
				})
			},
			exitSystem() {
				this.$alert('该操作将清除登录信息，是否继续？', '退出登录', {
					confirmButtonText: '确定',
					callback: action => {
						if (action == 'confirm') {
							cookie.removeToken()
							this.$router.replace('/login')
						}
					}
				});
			},
		}
	}
</script>

<style lang="scss" scoped>
	.dialog-footer{text-align: center;margin: -20px 0 30px;}
	.dialogbt{width:180px;}
	.container {
		ul {
			margin-block-start: 0em;
			margin-block-end: 0em;
			margin-inline-start: 0px;
			margin-inline-end: 0px;
			padding-inline-start: 0px;
			width: 100% !important;

			.el-menu-item {
				margin: 0px !important;
				width: 100% !important;
				display: flex;
				align-items: center;
				padding: 0 20px;
			}
		}

		.header {
			padding: 0 0.4rem;
			background: #303133;
			justify-content: space-between;
			align-items: center;
			color: #FFFFFF;

			.i-title {
				font-size: 0.5rem;
				font-weight: bold;
			}

			.userName {
				font-size: 0.32rem;
			}

			.exit {
				margin-left: 0.2rem;
				font-size: 0.32rem;
				color: white;
				cursor: pointer;
			}
		}
	}
</style>
<style>
	.changep .el-dialog__header{text-align:center;}
</style>


// WEBPACK FOOTER //
// src/views/index/index.vue